import axios from 'utils/axios';
import { AppointmentDisplayType, AppointmentsType, getAppointmentStatuses } from 'types';

export const getOutpatientCardCover = (patientId: string) => {
  return axios.get(`/api/v1/patients/${patientId}/cover`).then((res) => res.data);
};
